export const REFERRAL_COUNT = '/api/v1/user/referral/count';
export const REFERRAL_SUM =
  '/api/v1/financial-coordinator/distributions/referral/sum';
